import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLOtherLists = () => {
  return (
    <div className="html-container">
      <h1>HTML – Other Lists</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          Apart from Ordered (<code>&lt;ol&gt;</code>) and Unordered (<code>&lt;ul&gt;</code>) lists, HTML provides <strong>Description Lists</strong> (<code>&lt;dl&gt;</code>) for terms and their descriptions. These lists are useful for glossaries, FAQs, and metadata.
        </p>
      </section>

      {/* 2. Description Lists */}
      <section id="description-lists">
        <h2>2. Description Lists</h2>
        <p>
          A description list consists of <code>&lt;dl&gt;</code> (list container), <code>&lt;dt&gt;</code> (term), and <code>&lt;dd&gt;</code> (description):
        </p>
        <pre>
          <code>{`<dl>
  <dt>HTML</dt>
  <dd>HyperText Markup Language</dd>

  <dt>CSS</dt>
  <dd>Cascading Style Sheets</dd>

  <dt>JS</dt>
  <dd>JavaScript</dd>
</dl>`}</code>
        </pre>
      </section>

      {/* 3. Nested Description Lists */}
      <section id="nested-description-lists">
        <h2>3. Nested Description Lists</h2>
        <p>Description lists can be nested inside a description term or description:</p>
        <pre>
          <code>{`<dl>
  <dt>Fruits</dt>
  <dd>
    <dl>
      <dt>Apple</dt>
      <dd>Red or green fruit</dd>
      <dt>Banana</dt>
      <dd>Yellow fruit</dd>
    </dl>
  </dd>
</dl>`}</code>
        </pre>
      </section>

      {/* 4. Mixed Lists */}
      <section id="mixed-lists">
        <h2>4. Mixed Lists</h2>
        <p>HTML allows mixing different list types:</p>
        <pre>
          <code>{`<ol>
  <li>Fruits
    <ul>
      <li>Apple</li>
      <li>Banana</li>
    </ul>
  </li>
  <li>Vegetables
    <ul>
      <li>Carrot</li>
      <li>Spinach</li>
    </ul>
  </li>
</ol>`}</code>
        </pre>
        <p>This creates a numbered list of categories, with bullet points for items inside each category.</p>
      </section>

      {/* 5. Styling Other Lists */}
      <section id="list-styling">
        <h2>5. Styling Description and Mixed Lists</h2>
        <pre>
          <code>{`.html-container dl {
  margin: 1rem 0;
  padding: 0;
  color: #007bff;
}

.html-container dt {
  font-weight: bold;
  margin-top: 0.5rem;
}

.html-container dd {
  margin-left: 1.5rem;
}

.html-container ol ul {
  margin-left: 1rem;
  list-style-type: disc;
}`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Use description lists for term-definition pairs.</li>
          <li>Use mixed lists to show hierarchy (numbers for categories, bullets for items).</li>
          <li>Keep nested lists simple to maintain readability.</li>
          <li>Always style lists with CSS instead of relying on default browser styles.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>Description lists (<code>&lt;dl&gt;</code>) define terms (<code>&lt;dt&gt;</code>) and their descriptions (<code>&lt;dd&gt;</code>).</li>
          <li>Mixed lists combine ordered and unordered lists for structured content.</li>
          <li>CSS can be used to improve readability and presentation of lists.</li>
          <li>Nested lists should be used carefully to avoid clutter.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLOtherLists;
